/* eslint-disable */
import * as Types from '../../../models/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type ResetPasswordAnonymouslyVariablesDTO = Types.Exact<{
  data: Types.PasswordResetInputDTO;
}>;


export type ResetPasswordAnonymouslyDTO = (
  { __typename?: 'Mutation' }
  & { resetPassword: (
    { __typename?: 'Success' }
    & Pick<Types.SuccessDTO, 'success'>
  ) }
);


export const ResetPasswordAnonymouslyDocumentDTO = gql`
    mutation resetPasswordAnonymously($data: PasswordResetInput!) {
  resetPassword(data: $data) {
    success
  }
}
    `;
export type ResetPasswordAnonymouslyMutationFnDTO = Apollo.MutationFunction<ResetPasswordAnonymouslyDTO, ResetPasswordAnonymouslyVariablesDTO>;

/**
 * __useResetPasswordAnonymously__
 *
 * To run a mutation, you first call `useResetPasswordAnonymously` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordAnonymously` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordAnonymously, { data, loading, error }] = useResetPasswordAnonymously({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useResetPasswordAnonymously(baseOptions?: Apollo.MutationHookOptions<ResetPasswordAnonymouslyDTO, ResetPasswordAnonymouslyVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordAnonymouslyDTO, ResetPasswordAnonymouslyVariablesDTO>(ResetPasswordAnonymouslyDocumentDTO, options);
      }
export type ResetPasswordAnonymouslyHookResult = ReturnType<typeof useResetPasswordAnonymously>;
export type ResetPasswordAnonymouslyMutationResultDTO = Apollo.MutationResult<ResetPasswordAnonymouslyDTO>;
export type ResetPasswordAnonymouslyMutationOptionsDTO = Apollo.BaseMutationOptions<ResetPasswordAnonymouslyDTO, ResetPasswordAnonymouslyVariablesDTO>;